import Table from "react-bootstrap/Table";
import UnstakeRow from "./UnstakeRow";

export default function UnstakeTable({
  data,
  onClaimUnstaked,
  isClaimingUnstaked,
  estimateClaimUnstakedGas,
  token
}) {
  // console.log(data, "UnstakeTable data");

  return (
    <Table>
      <thead>
        <tr>
          <th>Unstaked On</th>
          <th>Available In</th>
          <th>Amount</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {data.length > 0 ? (
          data.map((item,index) => (
            <UnstakeRow
              key={index}
              item={item}
              index={item?.index}
              onClaimUnstaked={onClaimUnstaked}
              isClaimingUnstaked={isClaimingUnstaked}
              estimateClaimUnstakedGas={estimateClaimUnstakedGas}
              token ={token}
            />
          ))
        )
        : (
          <tr className="foundtable">
            <td colSpan="4" className="text-center py-4 ">
              No unstake requests found
            </td>
          </tr>
        )
        }
      </tbody>
    </Table>
  );
}
